import Vue from 'vue'
import App from './App.vue'
import './registerServiceWorker'
import router from './router'
import store from './store'
import { SOCKET_SERVER_SOCKET_BASE_URL } from "./store/variables.js"
import vuescroll from "vuescroll/dist/vuescroll-native";
import "vuescroll/dist/vuescroll.css";
import "./scss/main.scss";
import 'vue2-animate/dist/vue2-animate.min.css'
import * as VueGoogleMaps from 'vue2-google-maps';
import AppMix from './mixin/appMix.vue';
import axios from 'axios';
import VueAxios from 'vue-axios';
import Notifications from 'vue-notification';
import VueLocalStorage from 'vue-localstorage';
import VueClosable from 'vue-closable';
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import CButton from '@/components/partials/CButton.vue';
import DropdownMenu from "@innologica/vue-dropdown-menu";
import VueConfirmDialog from 'vue-confirm-dialog'
import VueClipboard from 'vue-clipboard2'
import VueContentLoading from 'vue-content-loading';
import Uploader from './components/modals/upload-helper';
import GoogleMap from './components/modals/map-helper';
import AdminContainer from "./views/AdminContainer.vue";
import widgetButton from "./components/widget/widgetButton.vue";
import widgetInput from "./components/widget/widgetInput.vue";
import widgetMediaTimeInput from "@/components/widget/widgetMediaTimeInput.vue"
import widgetTextarea from "./components/widget/widgetTextarea.vue";
import widgetSearch from "./components/widget/widgetSearch.vue";
import widgetCheckbox from "./components/widget/widgetCheckbox.vue";
import widgetSelect from "./components/widget/widgetSelect.vue";
import widgetBadget from "./components/widget/widgetBadget.vue";
import widgetWizard from "./components/widget/widgetWizard.vue";
import widgetTabs from "./components/widget/widgetTabs.vue";
import widgetProgressBar from "./components/widget/widgetProgressBar.vue";
import widgetUpload from "./components/widget/widgetUpload.vue";
import widgetQuantity from "./components/widget/widgetQuantity.vue";
import widgetAppointmentcarendal from "./components/widget/widgetAppointmentcarendal.vue";
import widgetPagination from "./components/widget/widgetPagination.vue";
import widgetinputButton from "./components/widget/widgetinputButton.vue";
import widgetPagePath from "./components/widget/widgetPagePath.vue";
import widgetModal from "./components/widget/widgetModal.vue";
import widgetLoadingToSuccess from "./components/widget/widgetLoadingToSuccess.vue";
import widgetLoadingItems from "./components/widget/widgetLoadingItems.vue";
import widgetWrapper from "./components/widget/widgetWrapper.vue";
import MoviePlayerInput from "./components/modals/MoviePlayerInput.vue";
import widgetCounter from "./components/widget/widgetCounter.vue";
import widgetListItem from "./components/widget/widgetListItem.vue";
import VueApexCharts from 'vue-apexcharts';
import widgetStatus from "./components/widget/widgetStatus.vue";
import widgetTagsInput from "./components/widget/widgetTagsInput.vue";
import widgetNotfound from "./components/widget/widgetNotfound.vue";
import widgetProfile from "@/components/widget/widgetProfile.vue";
import widgetNotAllowed from "@/components/widget/widgetNotAllowed.vue"
import userFullDetails from "@/views/ADMIN/Members/components/userFullDetails.vue";
import widgetQrCodePreview from "./components/widget/widgetQrCodePreview.vue";

import VueSocketIO from 'vue-socket.io'
import SocketIO from 'socket.io-client'
import Buefy from 'buefy'
import "@/scss/buefy.scss"
import VueCompositionAPI from '@vue/composition-api';




// ==== Players =====
const ShakaPlayer = () => import(/* webpackPrefetch: true */ "@/components/partials/players/ShakaPlayer.vue");
const ClapprPlayer = () => import(/* webpackPrefetch: true */ "@/components/partials/players/ClapprPlayer.vue");
const VideoJSPlayer = () => import(/* webpackPrefetch: true */ "@/components/partials/players/VideoJSPlayer.vue");
const OvenPlayer = () => import(/* webpackPrefetch: true */ "@/components/partials/players/OvenPlayer.vue");
const PlyrPlayer = () => import(/* webpackPrefetch: true */ "@/components/partials/players/PlyrPlayer.vue");
const YTPlayer = () => import(/* webpackPrefetch: true */ "@/components/partials/players/YTPlayer.vue");
const PaymentWidget = () => import(/* webpackPrefetch: true */ "./components/modals/PaymentWidget");

Vue.use(VueCompositionAPI);



import {
    Select,
    Progress,
    Alert,
    Input,
    Icon,
    DatePicker,
    Button,
    Tabs,
    Empty,
    Spin,
    TimePicker,
    Checkbox,
    Rate,
    Popconfirm,
    Tooltip,
    Slider
} from 'ant-design-vue';
import "./scss/ant.scss";
Vue.use(Progress);
Vue.use(Alert);
Vue.use(Input);
Vue.use(Icon);
Vue.use(DatePicker);
Vue.use(Button);
Vue.use(Tabs);
Vue.use(Spin);
Vue.use(Empty);
Vue.use(TimePicker);
Vue.use(Checkbox);
Vue.use(Rate);
Vue.use(Popconfirm);
Vue.use(Tooltip);
Vue.use(Slider);
Vue.use(Select);
Vue.use(GoogleMap);
Vue.use(Uploader);
Vue.use(VueConfirmDialog);
Vue.use(Loading);
Vue.use(VueClosable);
Vue.use(VueLocalStorage);
Vue.use(Notifications);
Vue.use(VueAxios, axios);
Vue.use(VueClipboard);
Vue.mixin(AppMix);
Vue.use(VueGoogleMaps, {
    load: {
        key: store.state.GOOGLE_MAP_KEY,
        libraries: 'places',
    }
});
Vue.use(vuescroll, {
    ops: {
        bar: {
            showDelay: 200,
            onlyShowBarOnScroll: true,
            keepShow: true,
            background: '#ddd',
            opacity: 1,
            specifyBorderRadius: false,
            minSize: 0,
            size: '10px',
            disable: false
        }
    }
});
Vue.use(VueApexCharts)



const socketServer = SocketIO(SOCKET_SERVER_SOCKET_BASE_URL, {
    useConnectionNamespace: true,
    autoConnect: true,
    path: "/socket.io/"
});
Vue.use(new VueSocketIO({
    debug: false,
    connection: {
        socketServer
    },
    vuex: {
        store,
        actionPrefix: eventName => {
            return (`SOCKET_` + eventName).toUpperCase();
        },
        mutationPrefix: eventName => {
            return (`SOCKET_` + eventName).toUpperCase();
        },
    }
}));





Vue.use(Buefy);




Vue.component('apexchart', VueApexCharts)
Vue.component("widgetButton", widgetButton);
Vue.component('widgetInput', widgetInput);
Vue.component('widgetTextarea', widgetTextarea);
Vue.component('widgetSearch', widgetSearch);
Vue.component('widgetCheckbox', widgetCheckbox);
Vue.component('widgetSelect', widgetSelect);
Vue.component('widgetBadget', widgetBadget);
Vue.component('widgetDropdown', DropdownMenu);
Vue.component('widgetWizard', widgetWizard);
Vue.component('widgetTabs', widgetTabs);
Vue.component('widgetProgressBar', widgetProgressBar);
Vue.component('widgetUpload', widgetUpload);
Vue.component('widgetQuantity', widgetQuantity);
Vue.component('widgetAppointmentCarendal', widgetAppointmentcarendal);
Vue.component('widgetPagination', widgetPagination);
Vue.component('widgetinputButton', widgetinputButton);
Vue.component('widgetPagePath', widgetPagePath);
Vue.component('widgetModal', widgetModal);
Vue.component('widgetLoadingToSuccess', widgetLoadingToSuccess);
Vue.component('widgetLoadingItems', widgetLoadingItems);
Vue.component('widgetInputWrapper', widgetWrapper);
Vue.component('widgetCounter', widgetCounter);
Vue.component('widgetListItem', widgetListItem);
Vue.component('widgetStatus', widgetStatus);
Vue.component('widgetNotAllowed', widgetNotAllowed);
Vue.component('widgetTagsInput', widgetTagsInput);
Vue.component('AdminContainer', AdminContainer);
Vue.component('VueContentLoading', VueContentLoading);
Vue.component('vue-confirm-dialog', VueConfirmDialog.default);
Vue.component('CButton', CButton);
Vue.component('Loading', Loading);
Vue.component('DropdownMenu', DropdownMenu);
Vue.component('widgetCounter', widgetCounter);
Vue.component('widgetNotfound', widgetNotfound);
Vue.component('widgetProfile', widgetProfile);
Vue.component('userFullDetails', userFullDetails);
Vue.component('MoviePlayerInput', MoviePlayerInput);
Vue.component('widgetMediaTimeInput', widgetMediaTimeInput);
Vue.component('widgetQrCodePreview', widgetQrCodePreview);
Vue.component('ShakaPlayer', ShakaPlayer);
Vue.component('ClapprPlayer', ClapprPlayer);
Vue.component('VideoJSPlayer', VideoJSPlayer);
Vue.component('OvenPlayer', OvenPlayer);
Vue.component('PlyrPlayer', PlyrPlayer);
Vue.component('YTPlayer', YTPlayer);
Vue.component('PaymentWidget', PaymentWidget);


Vue.config.productionTip = false
// Setting for auth on load app
if (Vue.localStorage.get("user_data")) {
    let user_data = JSON.parse(Vue.localStorage.get("user_data"));
    store.commit("SET_TOKEN", user_data.access_token);
    store.dispatch("VERIFY_TOKEN", {
        token: user_data.access_token
    }).then(response => {
        if (response.data.status == 'ok') {
            store.commit("SET_TOKEN", user_data.access_token);
        } else if (response.data.status == 'remove') {
            Vue.localStorage.remove("user_data");
            router.push({ name: 'login' });
        }
    });
}

// Validate every axios request
axios.interceptors.response.use(function (response) {
    return response;
}, function (error) {
    try {
        if (error.response.status === 401) {
            store.commit("SET_TOKEN", null);
            Vue.localStorage.remove("user_data");
            router.push({ name: 'login' });
        }
    } catch (e) { }
    return Promise.reject(error);
});

// Router validation
router.beforeEach((to, from, next) => {
    if (to.matched.some(record => record.meta.requiresAuth)) {
        if (Vue.localStorage.get("user_data")) {
            let user_data = JSON.parse(Vue.localStorage.get("user_data"));
            store.commit("SET_TOKEN", user_data.access_token);
            store.dispatch("VERIFY_TOKEN", {
                token: user_data.access_token
            }).then(response => {
                if (response.data.status == 'ok') {
                    store.commit("SET_TOKEN", user_data.access_token);
                } else if (response.data.status == 'remove') {
                    Vue.notify({
                        group: "status",
                        type: "warn",
                        title: "Error message",
                        text: 'Your session expired, Please login again',
                    });
                    store.commit("SET_TOKEN", null);
                    Vue.localStorage.remove("user_data");
                    router.push({ name: 'login' });
                }
            });
        } else {
            Vue.notify({
                group: "status",
                type: "warn",
                title: "Error message",
                text: 'Your session expired, Please login again',
            });
            store.commit("SET_TOKEN", null);
            Vue.localStorage.remove("user_data");
            router.push({ name: 'login' });
        }
    } else {
        next()
        // make sure to always call next()!
    }

});

// if (process.env.NODE_ENV !== 'development') {
//     window.console.log = function () { };
// }

new Vue({
    router,
    store,
    render: h => h(App)
}).$mount('#app')
if (process.env.ENV !== "production") {
    console.log('Vue app is running in development mode');
}
